import React from 'react';
import CruiseImg from './CruiseImg';
import HotelImg from './HotelImg';
import type { Bundle, Tour } from '../types';

interface TourBundleGridProps {
    bundles: Bundle[];
    filter: string | null;
    clickBundleFunction: (bundleTours: string[]) => void;
    tours: Tour[];
}

function TourBundleGrid({ bundles, filter, clickBundleFunction, tours }: TourBundleGridProps) {
    return (
        <div>
            {bundles.map((bundle, index) => {
                if (filter === "Caye Visitors" && !bundle.cayes) return null;
                if (filter === "Cruise Passengers" && !bundle.cruise) return null;

                return (
                    <div key={index} className="tourBundleGrid">
                        <div>
                            <div className="tourBundleGridCentered" onClick={() => clickBundleFunction(bundle.tours)}>
                                <div>
                                    <div>{bundle.name}</div>
                                    <div className="tourBundleGridPrice">${bundle.price} Per Person</div>
                                    <div className="tourBundleGridSavings">Save $ {bundle.savings} per person</div>
                                </div>
                                <div className="tourBundleButtonContainer">
                                    <div className="tourBundleButton">Book This Bundle</div>
                                </div>
                            </div>
                            <ol className="tourBundleItems">
                                {bundle.tours.map((tour, tourIndex) => {
                                    const tourInfo = tours.find(o => o.name === tour);
                                    if (!tourInfo) return null;
                                    return (
                                        <li key={tourIndex} className="tourCardBundleItem">
                                            <div className="tourCardBundle"
                                                 style={{ backgroundImage: `url(${tourInfo.cardImage})` }}>
                                                <a className="tourBundleGridLink" href={tourInfo.url}>
                                                    {tourInfo.text}
                                                </a>
                                                <a href={tourInfo.url} className="seeTour">View this Tour</a>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ol>
                        </div>
                        <div className="bundleLogoGrid">
                            <div className="bundleLogo label">
                                <div className="bundleLogoTextContent">
                                    This Bundle is Available for Passengers coming to Placencia via:
                                </div>
                            </div>
                            <div className={filter === "Hotel Visitors" ? "bundleLogo chosen" : "bundleLogo"}>
                                <HotelImg small={true} />
                                <div className="bundleLogoItem">Hotel Visitors</div>
                            </div>
                            {bundle.cruise ? (
                                <div className={filter === "Cruise Passengers" ? "bundleLogo chosen" : "bundleLogo"}>
                                    <CruiseImg small={true} />
                                    <div className="bundleLogoItem">Cruise Passengers</div>
                                </div>
                            ) : (
                                <div className="bundleLogo empty"></div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default TourBundleGrid;
